import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CompanyLegacyModule } from '@core/components/legacy-input/search-one/company/company.module';
import { EquipmentTypeLegacyModule } from '@core/components/legacy-input/search-one/equipment-type/equipment-type.module';
import { LocationLegacyModule } from '@core/components/legacy-input/search-one/location/location.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterApprovalsEquipmentsComponent } from './filter-approvals-equipments.component';


@NgModule({
  declarations: [
    FilterApprovalsEquipmentsComponent
  ],
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatSelectModule,
    LocationLegacyModule,
    EquipmentTypeLegacyModule,
    CompanyLegacyModule
  ],
  exports: [
    FilterApprovalsEquipmentsComponent
  ]
})
export class FilterApprovalsEquipmentsModule {}
